import { render, staticRenderFns } from "./ProjectBudgetPricing.vue?vue&type=template&id=0f733fd6&scoped=true"
import script from "./ProjectBudgetPricing.vue?vue&type=script&lang=js"
export * from "./ProjectBudgetPricing.vue?vue&type=script&lang=js"
import style0 from "./ProjectBudgetPricing.vue?vue&type=style&index=0&id=0f733fd6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f733fd6",
  null
  
)

export default component.exports